import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Modal from '../../../Shared/Modal';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  modal: {
    width: '100%',
    maxWidth: 1000,
    padding: '0 40px 40px 40px',
  },
  modalContainer: {
    width: '100%',
    maxWidth: 1000,
  },
  modalSecondTitle: {
    paddingBottom: theme.spacing(2),
    padding: theme.spacing(0, 16),
    [theme.breakpoints.down(1000)]: {
      padding: theme.spacing(0),
    },
  },
  italic: {
    fontStyle: 'italic',
  },
  bold: {
    fontWeight: 600,
  },
  blueText: {
    color: '#172b4d',
    fontSize: '0.875rem',
    lineHeight: 1.43,
    marginTop: 20,
  },
  blackText: {
    fontSize: '0.875rem',
    lineHeight: 1.43,
    marginTop: 20,
  },
  text: {
    fontSize: '0.875rem',
    lineHeight: 1.43,
    marginTop: 20,
  },
  row: {
    display: 'flex',
    alignItems: 'baseline',
  },
  listItem: {
    margin: 5,
  },
  list: {
    margin: 0,
  },
  decimalList: {
    listStyleType: 'decimal',
  },
}));

const SNOT22Report = ({ showHelpPopup, setShowHelpPopup }) => {
  const classes = useStyles();
  const { en: { SNOT22Report } } = useSelector((state) => state.i18n);

  return (
    <Modal
      open={showHelpPopup}
      handleClose={() => {
        setShowHelpPopup(false);
      }}
      classes={{ paper: classes.modal, container: classes.modalContainer }}
      title={SNOT22Report.title}
      secondTitleStyle={classes.modalSecondTitle}
    >
      <div className={cx(classes.blackText, classes.bold)}>
        {SNOT22Report.firstPart}
      </div>
      <div className={cx(classes.blueText, classes.bold)}>
        {SNOT22Report.sinoNasalOutcomeTestTitle}
      </div>
      <div>{SNOT22Report.sinoNasalOutcomeTestText1}</div>
      <div className={cx(classes.text)}>
        {SNOT22Report.sinoNasalOutcomeTestText2}
      </div>
      <ul className={classes.list}>
        <li>
          <div className={classes.row}>
            <p className={cx(classes.blueText, classes.bold, classes.listItem)}>
              {SNOT22Report.sinoNasalOutcomeTestMildTitle}:
            </p>
            <p className={cx(classes.listItem)}>
              {SNOT22Report.sinoNasalOutcomeTestMildText}
            </p>
          </div>
        </li>
        <li>
          <div className={classes.row}>
            <p className={cx(classes.blueText, classes.bold, classes.listItem)}>
              {SNOT22Report.sinoNasalOutcomeTestModerateTitle}:
            </p>
            <p className={cx(classes.listItem)}>
              {SNOT22Report.sinoNasalOutcomeTestModerateText}
            </p>
          </div>
        </li>
        <li>
          <div className={classes.row}>
            <p className={cx(classes.blueText, classes.bold, classes.listItem)}>
              {SNOT22Report.sinoNasalOutcomeTestSevereTitle}:
            </p>
            <p className={cx(classes.listItem)}>
              {SNOT22Report.sinoNasalOutcomeTestSevereText}
            </p>
          </div>
        </li>
      </ul>
      <div className={cx(classes.text)}>
        {SNOT22Report.sinoNasalOutcomeTestText3}
      </div>
      <div className={cx(classes.text, classes.bold)}>
        {SNOT22Report.referencesTitle}
      </div>
      <ul className={cx(classes.decimalList, classes.list)}>
        <li>{SNOT22Report.referencesFirst}</li>
      </ul>
    </Modal>
  );
};

SNOT22Report.propTypes = {
  showHelpPopup: PropTypes.bool.isRequired,
  setShowHelpPopup: PropTypes.func.isRequired,
};

export default SNOT22Report;
